import { NoResults } from '@/components/NoResults';
import { getFreeSectionEmptyCopy, type SectionAssetType } from '@/utils/show-free-first/sectionCopy';

// Empty state shown when the free tier resolves empty but premium still has
// matches. Copy is keyed by asset type so the noun matches the surface.
export const FreeFirstNoFreeResults = ({
  assetType
}: {
  assetType: SectionAssetType;
}) => {
  const {
    title,
    subtitle
  } = getFreeSectionEmptyCopy(assetType);
  return <NoResults subtitle={subtitle} title={title} freeResults data-sentry-element="NoResults" data-sentry-component="FreeFirstNoFreeResults" data-sentry-source-file="FreeFirstNoFreeResults.tsx" />;
};